module.exports = __webpack_public_path__ + "img/bg-0-m.9d393782.webp";